import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

const steps = [
  { label: "Register your Mobile number", completed: true },
  { label: "Personal Information", completed: true },
  { label: "Register your email", completed: true },
  { label: "Accept Terms and Conditions", completed: true },
  { label: "Social Security Number", completed: false },
  { label: "Validate your identity", completed: false },
  { label: "Generate your credentials", completed: false },
  { label: "Initial Balance", completed: false },
];

export const RegionalOnboardingStepper = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    const currentParams = location.search;
    navigate(`/regional-onboarding_phone-corporativo-mobile${currentParams}`);
  };

  const handleBack = () => {
    const currentParams = location.search;
    navigate(`/regional-login-corporativo-mobile${currentParams}`);
  };

  return (
    <div className="regional-stepper">
      <div className="regional-stepper-container">
        {/* Dot Pattern Background */}
        <div className="stepper-dot-pattern">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(8)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.1 + (row * 0.05) + (col * 0.03);
                return (
                  <circle
                    key={`${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.secundario}
                    fillOpacity={Math.min(opacity, 0.8)}
                  />
                );
              })
            )}
          </svg>
        </div>

        {/* Header with Back Button */}
        <div className="stepper-header">
          <div className="back-button" onClick={handleBack}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke={colors.primario} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>

        {/* Title Section */}
        <div className="stepper-title-section">
          <h1 className="stepper-title">Steps to open your account</h1>
          <p className="stepper-subtitle">
            Please review the steps required to complete your account onboarding.
          </p>
        </div>

        {/* Steps List */}
        <div className="stepper-list-container">
          <div className="stepper-list">
            {steps.map((step, index) => (
              <div key={index} className="stepper-item">
                <div
                  className={`stepper-indicator ${step.completed ? 'completed' : 'pending'}`}
                  style={{
                    backgroundColor: step.completed ? colors.secundario : '#E5E7EB',
                    color: step.completed ? colors.primario : '#6B7280'
                  }}
                >
                  {step.completed ? (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.3334 4L6.00002 11.3333L2.66669 8" stroke={colors.primario} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  ) : (
                    <span>{index + 1}</span>
                  )}
                </div>
                <span className={`stepper-label ${step.completed ? 'completed' : ''}`}>
                  {step.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Action Button */}
        <div className="stepper-actions">
          <button
            className="btn-get-started"
            style={{ backgroundColor: colors.primario }}
            onClick={handleGetStarted}
          >
            Get started
          </button>
        </div>

        {/* Bottom Dot Pattern */}
        <div className="stepper-dot-pattern-bottom">
          <svg width="200" height="100" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(4)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.3 - (row * 0.05);
                return (
                  <circle
                    key={`bottom-${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.primario}
                    fillOpacity={Math.max(opacity, 0.1)}
                  />
                );
              })
            )}
          </svg>
        </div>
      </div>
    </div>
  );
};
